import de, { ui as uiDe } from "./features/de";
import en, { ui as uiEn } from "./features/en";
import es, { ui as uiEs } from "./features/es";
import it, { ui as uiIt } from "./features/it";
import fr, { ui as uiFr } from "./features/fr";

export const FEATURE_SLUGS = ["outfit-analyse", "farbanalyse", "outfit-vergleich", "glow-up"];

const CONTENT = { de, en, es, it, fr };
const UI = { de: uiDe, en: uiEn, es: uiEs, it: uiIt, fr: uiFr };

export const getFeature = (lang, slug) => (CONTENT[lang] || CONTENT.de)[slug];
export const getFeatureUi = (lang) => UI[lang] || UI.de;
export const getFeatureLinks = (lang) =>
  FEATURE_SLUGS.map((slug) => ({ slug, kicker: (CONTENT[lang] || CONTENT.de)[slug].kicker }));
